import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'maskString',
  standalone: true,
})
export class MaskStringPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return '';
    }
    const visibleChars = 4;
    const maskedPart = '*'.repeat(Math.max(0, value.length - visibleChars));
    const visiblePart = value.slice(-visibleChars);

    return maskedPart + visiblePart;
  }
}
